import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { AppConfig } from '../_helpers/appconfig.service';
import { ImportFileOptions } from '../sharedcomp/constans/importProcess.constans';
import { BatchFile, DataValidation, FieldValidation, FileValidation, PayoutVersion } from '../_models';
import { GeneratePresignedUrlResponse } from '../_models/uploadToS3.interface';
import { catchError, switchMap } from 'rxjs/operators';
import { fromFetch } from 'rxjs/fetch';

@Injectable({
  providedIn: 'root'
})

export class NewImportProcessBatchService {
  _kcmssvcURL: string = AppConfig.settings.apiServer.kcmssvcURL.toString();

  protected kcmssvcURL = this._kcmssvcURL;
  public defaultHeaders = new HttpHeaders();
  constructor(private http: HttpClient) { }

  generatePresignedUrl(objectName: string): Observable<GeneratePresignedUrlResponse> {
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    });

    return this.http.post<GeneratePresignedUrlResponse>(`${this.kcmssvcURL}/file_upload/generate-presigned-url`, objectName, { headers });
  }

  uploadFileToS3(formData: FormData, url: string): Observable<Response> {
    const requestOptions: RequestInit = {
      method: "POST",
      body: formData
    };

    return fromFetch(`${url}`, requestOptions)
    .pipe(
      switchMap(response => {
        if (!response.ok && response.status !== 204) {
          return throwError(new Error(`Failed to upload file. Status: ${response.status}`));
        }
        return of(response);
      }),
      catchError(error => {
        return throwError(error);
      })
    );
  }

  completeFileUpload<T = PayoutVersion>(batchFile: string): Observable<FileValidation<T>> {
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    });

    return this.http.post<FileValidation<T>>(`${this.kcmssvcURL}/file_upload/complete-file-upload`, batchFile, { headers });
  }

  dataValidation(body: FormData, publicId: BatchFile['id'], url: string, observe: any = 'body', reportProgress: boolean = false): Observable<HttpResponse<DataValidation>> {
    if (body == null) {
      throw new Error('Required parameter body was null or undefined when file rendering.');
    }

    const headers = this.defaultHeaders;
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');

    return this.http.post<DataValidation>(`${this.kcmssvcURL}/${url}/data_validation/${publicId}`,
      body,
      {
        headers: headers,
        observe: 'response'
      }
    );
  }

  fieldValidation(body: FormData, url: string, publicId: BatchFile['id'], observe: any = 'body', reportProgress: boolean = false): Observable<FieldValidation> {
    if (body == null) {
      throw new Error('Required parameter body was null or undefined when calling verify file validation.');
    }

    let headers = this.defaultHeaders;
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');

    return this.http.post<FieldValidation>(`${this.kcmssvcURL}/${url}/field_validation/${publicId}`,
      body,
      {
        headers: headers
      }
    );
  }

}
